import React, { useState } from "react";
import { Link, useLocation, useNavigate } from "react-router-dom";
import { Mail, Facebook } from "lucide-react";
import { NAV } from "@/constants/testIds";
import { useRegistry } from "@/context/RegistryContext";
import { useAuth } from "@/context/AuthContext";
import { SignupModal } from "@/components/SignupModal";

export const SUPPORT_EMAIL = "H3inclusive@gmail.com";
export const FACEBOOK_URL = "https://facebook.com/held4her";

export const Nav = () => {
  const location = useLocation();
  const navigate = useNavigate();
  const { profile, registry } = useRegistry();
  const { user, logout } = useAuth();
  const onDashboard = location.pathname.startsWith("/dashboard");
  const [openAuth, setOpenAuth] = useState(false);

  const handleCta = () => {
    if (user) navigate(profile ? "/dashboard" : "/onboarding");
    else setOpenAuth(true);
  };

  return (
    <>
      <SignupModal open={openAuth} onOpenChange={setOpenAuth} />
      <nav className="glass-nav sticky top-0 z-50">
        <div className="mx-auto max-w-6xl px-6 md:px-10 h-16 md:h-20 flex items-center justify-between">
          <Link
            to="/"
            data-testid={NAV.logo}
            className="font-display text-2xl md:text-[1.7rem] tracking-tight text-[#2D3732]"
          >
            held<span className="text-[#D98A71]">.</span>
          </Link>

          <div className="hidden md:flex items-center gap-8 text-sm text-[#5C6B62]">
            <Link to="/" data-testid={NAV.home} className="hover:text-[#2D3732] transition-colors">
              Story
            </Link>
            {user && profile && (
              <Link to="/dashboard" data-testid={NAV.marketplace} className="hover:text-[#2D3732] transition-colors">
                Marketplace
              </Link>
            )}
            <a
              href={`mailto:${SUPPORT_EMAIL}`}
              data-testid="nav-contact"
              className="hover:text-[#2D3732] transition-colors inline-flex items-center gap-1.5"
            >
              <Mail size={14} strokeWidth={1.5} />
              Contact
            </a>
            <a
              href={FACEBOOK_URL}
              target="_blank"
              rel="noreferrer"
              data-testid="nav-facebook"
              aria-label="Held on Facebook"
              className="hover:text-[#2D3732] transition-colors"
            >
              <Facebook size={16} strokeWidth={1.5} />
            </a>
            {user && (
              <span className="text-xs text-[#5C6B62]" data-testid="nav-user-name">
                Hi, {(user.full_name || "").split(" ")[0]}
              </span>
            )}
            {user && (
              <button
                onClick={logout}
                data-testid="nav-logout"
                className="text-xs text-[#5C6B62] hover:text-[#D98A71] transition-colors"
              >
                Sign out
              </button>
            )}
          </div>

          {!onDashboard && (
            <button
              onClick={handleCta}
              data-testid={NAV.cta}
              className="rounded-full bg-[#2D3732] text-[#FDFBF7] px-5 py-2.5 text-sm font-medium hover:bg-[#1e2521] transition-colors"
            >
              {user ? "Open registry" : "Begin"}
            </button>
          )}
        </div>
      </nav>
    </>
  );
};
